<template>
  <!-- eslint-disable vue/no-unused-refs -->
  <AppBarLayout>
    <template #default="{ activeHierarchy }">
      <div class="main tw-overflow-x-hidden">
        <brandpattern page="APPBARLAYOUT" />
        <backgroundComponent />

        <active-path-wrapper
          :active-hierarchy="activeHierarchy"
          button-title="Button"
          :is-button-enable="true"
        />
      </div>
    </template>
  </AppBarLayout>
</template>

<script lang="ts">
import ActivePathHeader from "@/components/common/activePathHeader.vue";
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import { Component, Vue } from "vue-facing-decorator";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import DetailsCard from "@/components/assessments/detailsCard.vue";
@Component({
  components: {
    AppBarLayout: AppBarLayout,
    ActivePathHeader: ActivePathHeader,
    brandpattern: BrandPattern4,
    backgroundComponent: backgroundComponent,
    ActivePathWrapper: ActivePathWrapper,
    DetailsCard: DetailsCard,
  },
})
export default class OrgManagement extends Vue {}
</script>

<style scoped>
.main {
  background: linear-gradient(64.12deg, #f1f2f3 0%, #eeeff0 100%);
  width: 100%;
  height: 100%;
  position: relative;
  overflow-x: hidden;
  min-width: 400px;
}
</style>
